var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFoundErrorAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700px",
    height: "600px",
    viewBox: "0 0 700 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "China@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "China",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 700,
    height: 600
  }), /*#__PURE__*/React.createElement("g", {
    id: "not-found-error-alert"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path27804",
    fill: "#3E4F59",
    points: "75 12.5 687.5 12.5 687.5 87.5 75 87.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path27806",
    fill: "#ACBEC2",
    points: "75 87.5 687.5 87.5 687.5 587.5 75 587.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,87.5 L75,587.5 L447.11925,587.5 C594.579202,454.418963 685.703051,258.716737 679.93175,87.5 L75,87.5 Z",
    id: "path27808",
    fill: "#E8EDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,0 C79.437375,0 62.5,16.9375 62.5,37.5 L62.5,537.5 C62.5,544.403625 68.0965,550 75,550 C81.903625,550 87.5,544.403625 87.5,537.5 L87.5,37.5 C87.5,30.448375 92.948375,25 100,25 L662.5,25 C669.55175,25 675,30.448375 675,37.5 L675,75 L150,75 C143.0965,75 137.5,80.5965 137.5,87.5 C137.5,94.403625 143.0965,100 150,100 L675,100 L675,562.5 C675,569.551625 669.55175,575 662.5,575 L50,575 C43.0965,575 37.5,580.5965 37.5,587.5 C37.5,594.403625 43.0965,600 50,600 L662.5,600 C683.062625,600 700,583.062625 700,562.5 C700,387.5 700,212.5 700,37.5 C700,16.9375 683.062625,0 662.5,0 L100,0 Z",
    id: "path27810",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.5,37.5 C630.5965,37.5 625,43.0965 625,50 C625,56.903625 630.5965,62.5 637.5,62.5 C644.403625,62.5 650,56.903625 650,50 C650,43.0965 644.403625,37.5 637.5,37.5 Z",
    id: "path27812",
    fill: "#ED7161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.5,37.5 C580.5965,37.5 575,43.0965 575,50 C575,56.903625 580.5965,62.5 587.5,62.5 C594.403625,62.5 600,56.903625 600,50 C600,43.0965 594.403625,37.5 587.5,37.5 Z",
    id: "path27814",
    fill: "#ECBA16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.5,37.5 C530.5965,37.5 525,43.0965 525,50 C525,56.903625 530.5965,62.5 537.5,62.5 C544.403625,62.5 550,56.903625 550,50 C550,43.0965 544.403625,37.5 537.5,37.5 Z",
    id: "path27816",
    fill: "#42B05C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,575 C5.59644063,575 0,580.596441 0,587.5 C0,594.403559 5.59644063,600 12.5,600 C19.4035594,600 25,594.403559 25,587.5 C25,580.596441 19.4035594,575 12.5,575 Z",
    id: "path27818",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5,75 C105.5965,75 100,80.5965 100,87.5 C100,94.403625 105.5965,100 112.5,100 C119.403625,100 125,94.403625 125,87.5 C125,80.5965 119.403625,75 112.5,75 Z",
    id: "path27820",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4427",
    fill: "#0075D3",
    x: 200.000125,
    y: 200,
    width: 362.5,
    height: 275,
    rx: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.000125,200 C211.150125,200 200.000125,211.15 200.000125,225 L200.000125,450 C200.000125,463.85 211.150125,475 225.000125,475 L469.799875,475 C507.171696,437.959125 527.723767,390.829629 527.758875,342.089875 C527.742102,289.079667 503.463769,238.14243 460.03425,200 L225.000125,200 Z",
    id: "path27648",
    fill: "#0588E2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8552",
    fill: "#FE73C5",
    x: 200.000125,
    y: 200,
    width: 362.5,
    height: 75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.000125,200 L200.000125,275 L507.373125,275 C508.233411,270.853287 508.689954,266.679367 508.740375,262.5 C508.73548,240.040867 497.008858,218.16031 475.24425,200 L200.000125,200 Z",
    id: "path8626",
    fill: "#FE93D3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "path4429",
    transform: "translate(187.500125, 187.500000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 87.5,
    x2: 375,
    y2: 87.5,
    id: "path7162",
    fill: "#918383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,0 C16.94125,0 -2.84217094e-14,16.94125 -2.84217094e-14,37.5 C-2.84217094e-14,62.150125 -2.84217094e-14,86.800125 -2.84217094e-14,111.45025 C-2.84217094e-14,118.35375 5.5965,123.95025 12.5,123.95025 C19.4035,123.95025 25,118.35375 25,111.45025 L25,100 L362.5,100 L362.5,175 C362.5,181.9035 368.0965,187.5 375,187.5 C381.9035,187.5 387.5,181.9035 387.5,175 C387.5,129.166625 387.5,83.333375 387.5,37.5 C387.5,16.94125 370.55875,0 350,0 L37.5,0 Z M37.5,25 L350,25 C357.14125,25 362.5,30.35875 362.5,37.5 L362.5,75 L25,75 L25,37.5 C25,30.35875 30.35875,25 37.5,25 Z M12.5,150 C5.5965,150 -2.84217094e-14,155.5965 -2.84217094e-14,162.5 L-2.84217094e-14,262.5 C-2.84217094e-14,283.05875 16.94125,300 37.5,300 L350,300 C370.55875,300 387.5,283.05875 387.5,262.5 L387.5,225 C387.5,218.0965 381.9035,212.5 375,212.5 C368.0965,212.5 362.5,218.0965 362.5,225 L362.5,262.5 C362.5,269.64125 357.14125,275 350,275 L37.5,275 C30.35875,275 25,269.64125 25,262.5 L25,162.5 C25,155.5965 19.4035,150 12.5,150 Z",
    id: "path7164",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.1945,312.524375 C268.546125,312.890625 263.848875,317.00725 262.74425,322.558625 L250.24425,385.058625 C248.70575,392.789125 254.618125,399.996875 262.500125,400 L300.000125,400 L300.000125,425 C300.000125,431.9035 305.596625,437.5 312.500125,437.5 C319.403625,437.5 325.000125,431.9035 325.000125,425 C325.000125,404.166625 325.000125,383.333375 325.000125,362.5 C325.000125,355.5965 319.403625,350 312.500125,350 C305.596625,350 300.000125,355.5965 300.000125,362.5 L300.000125,375 L277.7345,375 L287.256,327.441375 C288.602375,320.673 284.209125,314.094125 277.4415,312.744125 C276.374,312.529125 275.28175,312.455375 274.1945,312.524125 L274.1945,312.524375 Z",
    id: "path8873",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.5,325 C401.350125,325 412.50025,336.150125 412.50025,350.00025 L412.50025,387.49975 C412.50025,401.349875 401.350125,412.5 387.5,412.5 C373.649875,412.5 362.49975,401.349875 362.49975,387.49975 L362.49975,350.00025 C362.49975,336.150125 373.649875,325 387.5,325 Z",
    id: "rect5745",
    fill: "#FFC343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.500125,312.5 C366.94125,312.5 350.000125,329.441125 350.000125,350 L350.000125,387.5 C350.000125,408.058875 366.94125,425 387.500125,425 C408.059,425 425.000125,408.058875 425.000125,387.5 L425.000125,350 C425.000125,343.096441 419.403684,337.5 412.500125,337.5 C405.596566,337.5 400.000125,343.096441 400.000125,350 L400.000125,387.5 C400.000125,394.641375 394.6415,400 387.500125,400 C380.35875,400 375.000125,394.641375 375.000125,387.5 L375.000125,350 C375.000125,342.858625 380.35875,337.5 387.500125,337.5 C394.403684,337.5 400.000125,331.903559 400.000125,325 C400.000125,318.096441 394.403684,312.5 387.500125,312.5 Z",
    id: "path7169",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.1945,312.524375 C468.546125,312.890625 463.848875,317.00725 462.74425,322.558625 L450.24425,385.058625 C448.70575,392.789125 454.618125,399.996875 462.500125,400 L500.000125,400 L500.000125,425 C500.000125,431.9035 505.596625,437.5 512.500125,437.5 C519.403625,437.5 525.000125,431.9035 525.000125,425 C525.000125,404.166625 525.000125,383.333375 525.000125,362.5 C525.000125,355.5965 519.403625,350 512.500125,350 C505.596625,350 500.000125,355.5965 500.000125,362.5 L500.000125,375 L477.7345,375 L487.256,327.441375 C488.602375,320.673 484.209125,314.094125 477.4415,312.744125 C476.374,312.529125 475.28175,312.455375 474.1945,312.524125 L474.1945,312.524375 Z",
    id: "path69785",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundErrorAlert);
export default __webpack_public_path__ + "static/media/not-found-error-alert.67ef3176cc295b5ebad3d7e0b3344991.svg";
export { ForwardRef as ReactComponent };